export function objectKeysToPascalCase(obj: any): any {
	return Object.entries(obj)
		.reduce((out: any, [currentKey, currentValue]) => {
			const pascalKey = currentKey[0].toUpperCase() + currentKey.substr(1);

			out[pascalKey] = currentValue;

			return out;
		}, {});
}
